import {
  IconCityLocation,
  IconPerson,
  IconFilledHome,
  IconSetting,
  IconWorkHome,
  IconJob,
  IconPartner,
  IconSocialGroupAdd,
  IconLegalDocs,
  IconBusinessReportLine,
  IconManagementLedger,
} from "@/assets/icons";
import {
  AppRoutes,
  CompanyRoutes,
  MatchRoutes,
  UserSettingRoutes,
  JobRoutes,
  CasesRoutes,
  TalentRoutes,
  PartnerRoutes,
  BusinessReportRoutes,
  ManagementLedgerRoutes,
} from "@/routes/config";

type TMenuIcon = (props: React.SVGProps<SVGSVGElement>) => React.JSX.Element;

type TMenuLeaf = {
  text: string;
  icon?: TMenuIcon;
  path: string;
  relatedRoutes: readonly string[];
};

type TMenuGroup = {
  text: string;
  icon?: TMenuIcon;
  children: TMenuLeaf[];
};

export type TMenuEntry = TMenuLeaf | TMenuGroup | string;

export const menus: readonly TMenuEntry[] = [
  {
    text: "ホーム",
    icon: IconFilledHome,
    path: AppRoutes.home,
    relatedRoutes: [AppRoutes.home, AppRoutes.offerAcceptedList, AppRoutes.performanceDetail],
  },
  {
    text: "案件管理",
    icon: IconSocialGroupAdd,
    path: AppRoutes.caseList,
    relatedRoutes: CasesRoutes,
  },
  {
    text: "企業管理",
    icon: IconCityLocation,
    path: AppRoutes.companyList,
    relatedRoutes: CompanyRoutes,
  },
  {
    text: "求人管理",
    icon: IconJob,
    path: AppRoutes.jobList,
    relatedRoutes: JobRoutes,
  },
  {
    text: "人材管理",
    icon: IconPerson,
    path: AppRoutes.talentList,
    relatedRoutes: TalentRoutes,
  },
  {
    text: "パートナー管理",
    icon: IconPartner,
    path: AppRoutes.partnerList,
    relatedRoutes: PartnerRoutes,
  },
  "|",
  {
    text: "法定帳票",
    icon: IconLegalDocs,
    children: [
      {
        text: "事業報告書",
        icon: IconBusinessReportLine,
        path: AppRoutes.businessReport,
        relatedRoutes: BusinessReportRoutes,
      },
      {
        text: "管理簿",
        icon: IconManagementLedger,
        path: AppRoutes.managementLedger,
        relatedRoutes: ManagementLedgerRoutes,
      },
    ],
  },
  "|",
  {
    text: "紹介会社情報",
    icon: IconWorkHome,
    path: AppRoutes.match,
    relatedRoutes: MatchRoutes,
  },
  {
    text: "ユーザー設定",
    icon: IconSetting,
    path: AppRoutes.userSettingDetail,
    relatedRoutes: UserSettingRoutes,
  },
  // === Not found design
  "booking",
];
